import {SIGNIN_SUCCESS, SIGNIN_FAILURE, SIGNIN_ERROR_CLEAR, LOGOUT} from '../../constants/actionTypes';
import {saveStoredUser} from '../../utils';

const initialState = {
    signInSuccess: false,
    signInError: false,
    isAuthenticated: false,
    userData: null,
    token: null,
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case SIGNIN_SUCCESS: {
            const normalizedUser = saveStoredUser(action.payload);
            return {
                ...state,
                signInSuccess: true,
                signInError: false,
                isAuthenticated: true,
                userData: normalizedUser.data,
                token: normalizedUser.token,
            };
        }
        case SIGNIN_FAILURE:
            localStorage.removeItem('user');
            return {
                ...state,
                signInSuccess: false,
                signInError: action.payload,
                isAuthenticated: false,
                userData: null,
                token: null,
            };
        case SIGNIN_ERROR_CLEAR:
            return {
                ...state,
                signInError: false,
            };
        case LOGOUT:
            localStorage.clear();
            return {
                signInSuccess: false,
                signInError: false,
                isAuthenticated: false,
                userData: null,
                token: null,
            };
        default:
            return state;
    }
};

export default userReducer;
